import { $isTableNode, TableNode } from '@lexical/table';
import { LexicalNode } from 'lexical';

const HTML_ORIGIN_KEY = '__htmlOrigin';

export function markAsHtmlOrigin(node: LexicalNode): void {
  if ($isTableNode(node)) {
    (node as TableNode & { [HTML_ORIGIN_KEY]: boolean })[HTML_ORIGIN_KEY] = true;
  }
}

export function isHtmlOrigin(node: LexicalNode): boolean {
  return (node as TableNode & { [HTML_ORIGIN_KEY]?: boolean })[HTML_ORIGIN_KEY] === true;
}
